import StrUtils from '@/utils/StrUtils'

export const POL = 'POL'
export const COL = 'COL'
export const ROL = 'ROL'
export const POD = 'POD'
export const COD = 'COD'
export const ROD = 'ROD'
export const CARRIER = 'CARRIER'
export const OFFICE = 'OFFICE'
export const TENANT = 'TENANT'

export const FIELDS = new Set([OFFICE, TENANT, POL, COL, ROL, POD, COD, ROD, CARRIER])
/**
 * 专门处理运价订阅设置的限定条件<br>
 * POL,COL,ROL,POD,COD,ROD,CARRIRR,LE,OFFICE,TENANT
 * @author Jay Zhang
 */
export class PriceSubscribeShape {
  constructor(shape) {
    this._shape = shape
    this.isDirty = false
    this._map = {}
    this.parse()
  }
  parse() {
    if (this._shape && this._shape.indexOf(':') > -1) {
      const conditions = this._shape.split(';')
      this._map = {}
      let pairs = []
      if (conditions) {
        conditions.forEach(condition => {
          pairs = condition.split(':')
          this._map[pairs[0]] = pairs[1]
        })
      }
      if (this._map.hasOwnProperty(CARRIER)) {
        const cr = this._map[CARRIER]
        if (cr.charAt(0) === ',') {
          this._map[CARRIER] = cr
        } else {
          this._map[CARRIER] = StrUtils.substitute(',{0},', cr) // 防止Carrier出现shortName部分匹配
        }
      }
    }
  }
  toString() {
    const source = []
    for (const key of FIELDS) {
      if (this._map.hasOwnProperty(key)) {
        source.push(key + ':' + this._map[key])
      }
    }
    const newShape = source.join(';')
    this.isDirty = newShape !== this._shape
    return newShape
  }
  has(key) {
    return this._map.hasOwnProperty(key)
  }
  getVal(key) {
    return this._map.hasOwnProperty(key) ? this._map[key] : ''
  }
  getOffice() {
    return this.getVal(OFFICE)
  }
  setTenant(value) {
    this.setVal(TENANT, value)
  }
  getTenant() {
    return this.getVal(TENANT)
  }
  getPol() {
    return this.getVal(POL)
  }
  getCol() {
    return this.getVal(COL)
  }
  getRol() {
    return this.getVal(ROL)
  }
  setVal(key, value) {
    if (value) {
      this._map[key] = value
    } else {
      delete this._map[key]
    }
  }
}
